/* eslint-disable */
import { Component, HostListener, ViewChild, } from '@angular/core';
import { FieldValidationError, FormRef, LocalFormGroupValidationErrors, } from '../../../../../../../lib/util/services';
import {
  FormEditFieldCreateDialogView,
  FormEditFieldDialogContext,
  FormEditFieldUpdateDialogView,
  FormGroupModel,
  FormModel,
} from '../../../../../../../util/form/form-utils';
import { Form } from '../../../../../../../lib/form/form.service';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { FormBuilder, FormGroup, Validators, } from '@angular/forms';
import { FieldWidthType } from '../../../../../../../util/form/form-field-width-type';
import { InputMask } from '../../../../../../../util/input-masks';
import { AppNgbTimeStruct, NgbDatePickerParserFormatter } from '../../../../../../../util/ngb-datepicker';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { AppValidators } from '../../../../../../../util/app-validators';
import { Models } from '../../../../../../../util/model-utils';
import { Dates } from '../../../../../../../lib/util/dates';
import {
  FieldValidationType,
  FormFieldValidationTypeModel,
} from '../../../../../../../util/form/form-field-validation-type';
import { UiConstants } from '../../../../../../../util/core-utils';

/* eslint-enable */

@Component({
  selector: 'app-form-edit-create-update-datetime-field-dialog',
  templateUrl: 'form-edit-create-update-datetime-field-dialog.component.html',
  styleUrls: ['form-edit-create-update-datetime-field-dialog.component.scss'],
})
export class FormEditCreateUpdateDateTimeFieldDialogComponent
  implements FormEditFieldCreateDialogView, FormEditFieldUpdateDialogView, FormRef {

  public readonly selector = Form.FieldDataTypeSelector.DATE_TIME;
  public readonly createTitle = 'FORM_ITEM_CREATE_DATE_TIME_TITLE';
  public readonly updateTitle = 'FORM_ITEM_UPDATE_DATE_TIME_TITLE';
  public readonly cloneTitle = 'FORM_ITEM_CLONE_DATE_TIME_TITLE';

  InputMask = InputMask;
  Form = Form;
  UiConstants = UiConstants;

  @ViewChild('fieldDialog', { static: true })
  dialogComponent: ModalDirective;

  formGroup: FormGroup;

  visible: boolean = false;
  fieldModel: Model;
  dialogTitleDictionaryKey: string = '';
  latestApiExportName = '';

  fieldWidthTypes: FieldWidthType[] = FieldWidthType.VALUES.toArray();
  fieldValidationTypes: Form.FormFieldValidationType[] = FieldValidationType.VALUES.toArray();

  private fieldErrors: FieldValidationError<Form.FieldValidatedField> =
    FieldValidationError.empty<Form.FieldValidatedField>();

  private formGroupValidationErrors: LocalFormGroupValidationErrors;

  private context: FormEditFieldDialogContext;
  private form?: FormModel;
  private group?: FormGroupModel;
  private field?: Form.Field;
  private clone?: boolean;
  private submitted: boolean = false;

  @HostListener('document:keydown.escape', ['$event'])
  onKeydownHandler(event: KeyboardEvent) {
    this.closeDialog();
  }

  constructor(
      private datePickerParserFormatter: NgbDatePickerParserFormatter,
      fb: FormBuilder) {
    this.fieldModel = new Model();
    this.formGroup = this.createFormGroup(fb);
    this.formGroupValidationErrors = LocalFormGroupValidationErrors.ofForm(this, this.formGroup);
  }

  getForm() {
    return {
      submitted: this.submitted
    };
  }

  registerContext(context: FormEditFieldDialogContext): void {
    this.context = context;
  }

  showDialog(form: FormModel, group: FormGroupModel, field?: Form.Field, clone?: boolean): void {
    this.latestApiExportName = '';
    this.visible = true;
    this.form = form;
    this.group = group;
    this.clone = clone;
    this.dialogComponent.show();
    if (field && clone) {
      this.dialogTitleDictionaryKey = this.cloneTitle;
      this.loadField(field);
    }
    else if (field) {
      this.dialogTitleDictionaryKey = this.updateTitle;
      this.loadField(field);
    }
    else {
      this.dialogTitleDictionaryKey = this.createTitle;
    }
  }

  onModalHide(event: ModalDirective) {
    if (event.dismissReason === 'backdrop-click' || event.dismissReason === 'esc') {
      this.visible = false;
      this.submitted = false;
      this.fieldModel = new Model();
    }
  }

  closeDialog(): void {
    this.visible = false;
    this.submitted = false;
    this.formGroup.reset();
    this.dialogComponent.hide();
    this.fieldModel = new Model();
  }

  saveField() {
    this.submitted = true;
    this.formGroup.updateValueAndValidity();
    if (this.formGroup.invalid) {
      return;
    }
    if (this.field && this.clone) {
      this.createField();
    }
    else if (this.field) {
      this.updateField(this.field);
    }
    else {
      this.createField();
    }
  }

  hasLocalFieldError(formControlName?: string, errorCode?: string): boolean {
    return this.formGroupValidationErrors.hasFieldError(formControlName, errorCode);
  }

  hasLocalFormError(errorCode: string): boolean {
    return this.formGroupValidationErrors.hasFormError(errorCode);
  }

  hasFieldError(field?: Form.FieldValidatedField): boolean {
    return this.fieldErrors.hasError(field);
  }

  removeFieldError(field: Form.FieldValidatedField) {
    this.fieldErrors = this.fieldErrors.removeError(field);
  }

  getFieldErrorText(field: Form.FieldValidatedField): string {
    return this.fieldErrors.getErrorText(field);
  }

  isDefaultDateDisabled(): boolean {
    return this.fieldModel.defaultToday;
  }

  isMinValueDisabled(): boolean {
    return this.fieldModel.disablePast;
  }

  isMaxValueDisabled(): boolean {
    return this.fieldModel.disableFuture;
  }

  isDisableFutureDisabled(): boolean {
    return this.fieldModel.disablePast;
  }

  dateDefaultTodayChanged() {
    if (this.fieldModel.defaultToday) {
      this.fieldModel.defaultValue = null;
    }
  }

  dateDisablePastChanged() {
    if (this.fieldModel.disablePast) {
      this.fieldModel.minValue = null;
      this.fieldModel.disableFuture = false;
      this.fieldModel.maxValue = null;
    }
    this.formGroup.get('minDateValue')!.updateValueAndValidity();
    this.formGroup.get('minTimeValue')!.updateValueAndValidity();
  }

  dateDisableFutureChanged() {
    if (this.fieldModel.disableFuture) {
      this.fieldModel.maxValue = null;
    }
    this.formGroup.get('minDateValue')!.updateValueAndValidity();
    this.formGroup.get('minTimeValue')!.updateValueAndValidity();
  }

  getFieldValidationTypeDictionaryKey(vt: Form.FormFieldValidationType): string {
    return FieldValidationType.getFieldValidationTypeDictionaryKey(vt);
  }

  onAdminFormFieldValidationTypeChanged() {
    FieldValidationType.onAdminFormFieldValidationTypeChanged(this.fieldModel);
  }

  onMobileFormFieldValidationTypeChanged() {
    FieldValidationType.onMobileFormFieldValidationTypeChanged(this.fieldModel);
  }

  private get startMaxValue(): (NgbDateStruct & AppNgbTimeStruct) | null {
    if (this.fieldModel.disableFuture) {
      return this.datePickerParserFormatter.fromOffsetDateTime(Dates.now());
    }
    return null;
  }

  private loadField(field: Form.Field) {
    this.field = field;
    const attrs = field.dataType.dateTimeAttributes!;
    const minValue = this.datePickerParserFormatter.fromOffsetDateTime(attrs.minValue);
    const maxValue = this.datePickerParserFormatter.fromOffsetDateTime(attrs.maxValue);
    const placeholder = attrs.hint;
    const defaultValue = this.datePickerParserFormatter.fromOffsetDateTime(attrs.defaultValue);
    const defaultToday = attrs.defaultToday;
    const disableFuture = attrs.disableFuture;
    const disablePast = attrs.disablePast;
    const fieldWidth = FieldWidthType.fromPercentValue(field.formFieldWidthPercent);
    this.fieldModel.title = field.title;
    this.fieldModel.description = field.description ? field.description : '';
    this.fieldModel.hint = field.hint ? field.hint : '';
    this.fieldModel.apiExportName = field.apiExportName ? field.apiExportName : '';
    this.fieldModel.pdfExportName = field.pdfExportName ? field.pdfExportName : '';
    this.fieldModel.minValue = minValue;
    this.fieldModel.maxValue = maxValue;
    this.fieldModel.defaultValue = defaultValue;
    this.fieldModel.fieldWidthType = fieldWidth ? fieldWidth : FieldWidthType.DEFAULT;
    this.fieldModel.displayOnNewRow = field.displayOnNewRow;
    this.fieldModel.placeholder = placeholder ? placeholder : '';
    this.fieldModel.defaultToday = defaultToday;
    this.fieldModel.disableFuture = disableFuture;
    this.fieldModel.disablePast = disablePast;
    this.fieldModel.adminVisibleOnFormDetail = field.admin.visibleOnFormDetail;
    this.fieldModel.mobileVisibleOnFormDetail = field.mobile.visibleOnFormDetail;
    this.fieldModel.mobileVisibleOnMasterDetail = field.mobile.visibleOnMasterDetail;
    this.fieldModel.adminFormFieldValidationType = field.admin.validationType;
    this.fieldModel.helpdeskFormFieldValidationType = field.helpdesk.validationType;
    this.fieldModel.mobileFormFieldValidationType = field.mobile.validationType;
    this.fieldModel.showOnReceipt = field.showOnReceipt;
  }

  private createField() {
    this.context.formService.createField({
      parentId: this.context.parentId,
      groupId: this.group!.groupId,
      title: this.fieldModel.title,
      description: this.fieldModel.description,
      hint: this.fieldModel.hint,
      pdfExportName: this.fieldModel.pdfExportName,
      apiExportName: this.fieldModel.apiExportName,
      dataTypeSelector: this.selector,
      dataType: this.getDataTypeRequest(),
      formFieldWidthPercent: this.fieldModel.fieldWidthType.percentValue,
      displayOnNewRow: this.fieldModel.displayOnNewRow,
      admin: {
        visibleOnFormDetail: this.fieldModel.adminVisibleOnFormDetail,
        validationType: this.fieldModel.adminFormFieldValidationType
      },
      helpdesk: {
        validationType: this.fieldModel.helpdeskFormFieldValidationType
      },
      mobile: {
        visibleOnFormDetail: this.fieldModel.mobileVisibleOnFormDetail,
        visibleOnMasterDetail: this.fieldModel.mobileVisibleOnMasterDetail,
        validationType: this.fieldModel.mobileFormFieldValidationType
      },
      showOnReceipt: this.fieldModel.showOnReceipt
    }).subscribe(
      (result) => {
        this.context.formView.reloadForm();
        this.closeDialog();
      },
      (error) => {
        if (error instanceof FieldValidationError) {
          this.fieldErrors = error.withFormRef(this);
        }
      }
    );
  }

  private updateField(field: Form.Field) {
    this.context.formService.updateField({
      parentId: this.context.parentId,
      groupId: this.group!.groupId,
      fieldId: field.fieldId,
      title: this.fieldModel.title,
      description: this.fieldModel.description,
      hint: this.fieldModel.hint,
      pdfExportName: this.fieldModel.pdfExportName,
      apiExportName: this.fieldModel.apiExportName,
      dataTypeSelector: this.selector,
      dataType: this.getDataTypeRequest(),
      formFieldWidthPercent: this.fieldModel.fieldWidthType.percentValue,
      displayOnNewRow: this.fieldModel.displayOnNewRow,
      admin: {
        visibleOnFormDetail: this.fieldModel.adminVisibleOnFormDetail,
        validationType: this.fieldModel.adminFormFieldValidationType
      },
      helpdesk: {
        validationType: this.fieldModel.helpdeskFormFieldValidationType
      },
      mobile: {
        visibleOnFormDetail: this.fieldModel.mobileVisibleOnFormDetail,
        visibleOnMasterDetail: this.fieldModel.mobileVisibleOnMasterDetail,
        validationType: this.fieldModel.mobileFormFieldValidationType
      },
      showOnReceipt: this.fieldModel.showOnReceipt
    }).subscribe(
      (result) => {
        this.context.formView.reloadForm();
        this.closeDialog();
      },
      (error) => {
        if (error instanceof FieldValidationError) {
          this.fieldErrors = error.withFormRef(this);
        }
      }
    );
  }

  private getDataTypeRequest(): Form.FieldDataType {
    const minValue = this.datePickerParserFormatter.toOffsetDateTime(this.fieldModel.minDateValue, this.fieldModel.minTimeValue);
    const maxValue = this.datePickerParserFormatter.toOffsetDateTime(this.fieldModel.maxDateValue, this.fieldModel.maxTimeValue);
    const defValue = this.datePickerParserFormatter.toOffsetDateTime(this.fieldModel.defaultDateValue, this.fieldModel.defaultTimeValue);
    return {
      dateTimeAttributes: {
        hint: this.fieldModel.placeholder,
        minValue: minValue,
        maxValue: maxValue,
        defaultValue: defValue,
        defaultToday: this.fieldModel.defaultToday,
        disableFuture: this.fieldModel.disableFuture,
        disablePast: this.fieldModel.disablePast
      }
    };
  }

  onTitleBlur() {
    const normalizedText = Models.normalizeText(this.fieldModel.title);
    if (this.fieldModel.apiExportName === '') {
      this.fieldModel.apiExportName = normalizedText;
    }
    if (this.fieldModel.pdfExportName === '') {
      this.fieldModel.pdfExportName = normalizedText;
    }
  }

  private createFormGroup(fb: FormBuilder): FormGroup {
    return fb.group(
      {
        title: fb.control(
          { value: this.fieldModel.title },
          [
            Validators.required,
          ]
        ),
        apiExportName: fb.control(
          { value: this.fieldModel.apiExportName },
          [
            Validators.required,
          ]
        ),
        minDateValue: fb.control(
          { value: this.fieldModel.minDateValue, disabled: this.isMinValueDisabled() },
          [
            AppValidators.validateNgbDateTime({
              datePickerParserFormatter: this.datePickerParserFormatter,
              dateValue: () => this.fieldModel.minDateValue,
              timeValue: () => this.fieldModel.minTimeValue,
            }),
            AppValidators.validateMaxNgbDateTime({
              maxValue: () => this.startMaxValue,
              value: () => this.fieldModel.minValue,
              datePickerParserFormatter: this.datePickerParserFormatter
            }),
          ]
        ),
        minTimeValue: fb.control(
          { value: this.fieldModel.minTimeValue, disabled: this.isMinValueDisabled() },
          [
            AppValidators.validateNgbDateTime({
              datePickerParserFormatter: this.datePickerParserFormatter,
              dateValue: () => this.fieldModel.minDateValue,
              timeValue: () => this.fieldModel.minTimeValue,
            }),
            AppValidators.validateMaxNgbDateTime({
              maxValue: () => this.startMaxValue,
              value: () => this.fieldModel.minValue,
              datePickerParserFormatter: this.datePickerParserFormatter
            }),
          ]
        ),
        maxDateValue: fb.control(
          { value: this.fieldModel.maxDateValue, disabled: this.isMaxValueDisabled() },
          [
            AppValidators.validateNgbDateTime({
              datePickerParserFormatter: this.datePickerParserFormatter,
              dateValue: () => this.fieldModel.maxDateValue,
              timeValue: () => this.fieldModel.maxTimeValue,
            })
          ]
        ),
        maxTimeValue: fb.control(
          { value: this.fieldModel.maxTimeValue, disabled: this.isMaxValueDisabled() },
          [
            AppValidators.validateNgbDateTime({
              datePickerParserFormatter: this.datePickerParserFormatter,
              dateValue: () => this.fieldModel.maxDateValue,
              timeValue: () => this.fieldModel.maxTimeValue,
            })
          ]
        ),
        defaultDateValue: fb.control(
          { value: this.fieldModel.defaultDateValue, disabled: this.isDefaultDateDisabled() },
          [
            AppValidators.validateNgbDateTime({
              datePickerParserFormatter: this.datePickerParserFormatter,
              dateValue: () => this.fieldModel.defaultDateValue,
              timeValue: () => this.fieldModel.defaultTimeValue,
            })
          ]
        ),
        defaultTimeValue: fb.control(
          { value: this.fieldModel.defaultTimeValue, disabled: this.isDefaultDateDisabled() },
          [
            AppValidators.validateNgbDateTime({
              datePickerParserFormatter: this.datePickerParserFormatter,
              dateValue: () => this.fieldModel.defaultDateValue,
              timeValue: () => this.fieldModel.defaultTimeValue,
            })
          ]
        )
      },
      {
        validator: AppValidators.validatorChain(
          AppValidators.validateOffsetDateTimeFromTo({
            allowEquality: false,
            fromDate: () => this.fieldModel.minDateValue,
            fromTime: () => this.fieldModel.minTimeValue,
            toDate: () => this.fieldModel.maxDateValue,
            toTime: () => this.fieldModel.maxTimeValue,
            datePickerParserFormatter: this.datePickerParserFormatter
          }),
          AppValidators.validateOffsetDateTimeRange({
            minDate: () => this.fieldModel.minDateValue,
            minTime: () => this.fieldModel.minTimeValue,
            maxDate: () => this.fieldModel.maxDateValue,
            maxTime: () => this.fieldModel.maxTimeValue,
            dateValue: () => this.fieldModel.defaultDateValue,
            timeValue: () => this.fieldModel.defaultTimeValue,
            datePickerParserFormatter: this.datePickerParserFormatter
          }),
        )
      }
    );
  }

}

export class Model implements FormFieldValidationTypeModel {

  title: string = '';
  description: string = '';
  apiExportName: string = '';
  pdfExportName: string = '';
  minDateValue: NgbDateStruct | null = null;
  minTimeValue: AppNgbTimeStruct = Models.zeroNgbTime();
  maxDateValue: NgbDateStruct | null = null;
  maxTimeValue: AppNgbTimeStruct = Models.zeroNgbTime();
  defaultDateValue: NgbDateStruct | null = null;
  defaultTimeValue: AppNgbTimeStruct = Models.zeroNgbTime();
  fieldWidthType: FieldWidthType = FieldWidthType.DEFAULT;
  displayOnNewRow: boolean = false;
  hint: string = '';
  placeholder: string = '';
  defaultToday: boolean = false;
  disableFuture: boolean = false;
  disablePast: boolean = false;
  adminVisibleOnFormDetail: boolean = true;
  mobileVisibleOnFormDetail: boolean = true;
  mobileVisibleOnMasterDetail: boolean = false;
  adminFormFieldValidationType: Form.FormFieldValidationType = Form.FormFieldValidationType.OPTIONAL;
  helpdeskFormFieldValidationType: Form.FormFieldValidationType = Form.FormFieldValidationType.OPTIONAL;
  mobileFormFieldValidationType: Form.FormFieldValidationType = Form.FormFieldValidationType.OPTIONAL;
  showOnReceipt?: boolean = false;

  get minValue(): NgbDateStruct &  AppNgbTimeStruct | null {
    return Models.mergeNgbDateAndTime(this.minDateValue, this.minTimeValue);
  }

  set minValue(value: NgbDateStruct &  AppNgbTimeStruct | null) {
    this.minDateValue = value;
    this.minTimeValue = value ? value : Models.zeroNgbTime();
  }

  get maxValue(): NgbDateStruct &  AppNgbTimeStruct | null {
    return Models.mergeNgbDateAndTime(this.maxDateValue, this.maxTimeValue);
  }

  set maxValue(value: NgbDateStruct &  AppNgbTimeStruct | null) {
    this.maxDateValue = value;
    this.maxTimeValue = value ? value : Models.zeroNgbTime();
  }

  get defaultValue(): NgbDateStruct &  AppNgbTimeStruct | null {
    return Models.mergeNgbDateAndTime(this.defaultDateValue, this.defaultTimeValue);
  }

  set defaultValue(value: NgbDateStruct &  AppNgbTimeStruct | null) {
    this.defaultDateValue = value;
    this.defaultTimeValue = value ? value : Models.zeroNgbTime();
  }

}
